<template>
    <div class="px-4">
        <div class="grid grid-cols-2 gap-4" v-if="isLoaded">
            <div>
                <InputText
                    v-model:inputValue="PlaceOrderStore.state.placeOrder.firstName"
                    :errorInfo="formErrorInfo[0]"
                    :isSubmitted="isSubmitted"
                    :isShowError="isShowError"
                    :inputLbl="lbl.shoppingcart.profile.firstname"
                    :maxLength="50"
                    @onChange="onValidateForm()"
                />
            </div>
            <div>
                <InputContactNumber
                    v-model:inputValue="PlaceOrderStore.state.placeOrder.contactNumber"
                    :errorInfo="formErrorInfo[1]"
                    :isSubmitted="isSubmitted"
                    :isShowError="isShowError"
                    :inputLbl="lbl.shoppingcart.profile.contactnumber"
                    :maxLength="12"
                    :minLength="12"
                    delimeter="-"
                    @onChange="onValidateForm()"
                />
            </div>
        </div>
    </div>
</template>

<script>
// helper
import { FormHelper } from '@/helper/FormHelper.js';
// components
import InputText from '@/components/Input/label/InputText.vue';
import InputContactNumber from '@/components/Input/label/InputContactNumber.vue';
// mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';

export default {
    name: "profileForm",
    inject: ['PlaceOrderStore'],
    mixins: [LocaleMixin,ModalMixin,AuthStatusMixin],
    components: {
        InputText,
        InputContactNumber
    },
    props:{
        //v-model
        formValid: Boolean
    },
    data: function() {
        return {
            isLoaded: false,
            isPayment: true,
            isValid: false,

            formErrorInfo: [],
            isSubmitted: false,
            isShowError: false,
        }
    },
    created: function() {
        this.formErrorInfo = FormHelper.genErrorInfo(2);
    },
    methods: {
        onAccountInit: function() {
            this.PlaceOrderStore.state.placeOrder.firstName = this.profile.firstName;
            this.PlaceOrderStore.state.placeOrder.lastName = this.profile.lastName;
            this.PlaceOrderStore.state.placeOrder.contactNumber = this.profile.contactNumber;
            this.isLoaded = true;
            this.onValidateForm();
        },
        onValidateForm: function () {
            this.isValid = FormHelper.validate(this.formErrorInfo);
            this.$emit('update:formValid', this.isValid);
        },
        submitForm: function() {
            this.isSubmitted = true;
            if (this.validate()) {
                return this.isValid;
            } else {
                this.modal.errorModal.clearModal()
                                    .setMsg(FormHelper.getFirstErrorItem(this.formErrorInfo).msg)
                                    .show();
            }
            return null
        },
        getData: function() {
            return this.PlaceOrderStore.state.placeOrder;
        },
        validate: function() {
            return FormHelper.validate(this.formErrorInfo);
        },
    }
}
</script>

<style>

</style>